import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

import type { VoiceNoteTemplateOption } from '../types/api';

interface TemplateSelectProps {
  templateOptions: VoiceNoteTemplateOption[];
  selectedTemplate: string | undefined;
  onSelectedTemplate: (value: string | undefined) => void;
}

export const TemplateSelect = ({
  templateOptions,
  selectedTemplate,
  onSelectedTemplate,
}: TemplateSelectProps) => {
  return (
    <>
      <Select
        defaultValue={selectedTemplate}
        onValueChange={onSelectedTemplate}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a template" />
        </SelectTrigger>
        <SelectContent className="vai-overflow-visible vai-z-[10001]">
          {templateOptions.map((option) => {
            return (
              <SelectItem key={option.id} value={option.id}>
                {option.name}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </>
  );
};
